// extracted by mini-css-extract-plugin
export default {"container":"Vl","overlay":"Wl","videoOverlay":"Xl","withHeader":"Yl","header":"Zl","close":"_l","content":"am"};